// src/cache/embed-config.constants.ts
import { env } from "@flote/env";
var DEV_BROWSER_CACHE_TTL_MS = 60 * 1e3;
var PROD_BROWSER_CACHE_TTL_MS = 5 * 60 * 1e3;
var isBrowser = typeof globalThis !== "undefined" && "document" in globalThis;
var _a, _b;
var browserMode = isBrowser ? (
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore – `import.meta` is provided by Vite at build time
  ((_a = import.meta.env) == null ? void 0 : _a.MODE) ?? ((_b = import.meta.env) == null ? void 0 : _b.VITE_NODE_ENV)
) : void 0;
var serverNodeEnv = !isBrowser ? env().NODE_ENV : void 0;
var BROWSER_CACHE_TTL_MS = isBrowser && browserMode === "development" ? DEV_BROWSER_CACHE_TTL_MS : PROD_BROWSER_CACHE_TTL_MS;
var isProdServer = !isBrowser && serverNodeEnv === "production";
var REDIS_CACHE_TTL_SEC = isProdServer ? 60 * 60 : 60 * 10;

// src/b2bwave-order-statuses.ts
var B2BWaveOrderStatus = {
  /** Order submitted but not yet paid (initial state) */
  SUBMITTED: 2,
  /** ACH payment failed/declined */
  ACH_FAILED: 19,
  /** ACH payment voided (cancelled after authorization) */
  ACH_VOIDED: 20,
  /** Cash on Delivery verified */
  COD_VERIFIED: 10,
  /** ACH Processing */
  ACH_PROCESSING: 21,
  /** ACH payment successfully completed. Ready to deliver */
  ACH_CLEARED_FOR_DELIVERY: 11
};
var B2BWaveOrderStatusName = {
  [B2BWaveOrderStatus.SUBMITTED]: "1. Submitted",
  [B2BWaveOrderStatus.ACH_CLEARED_FOR_DELIVERY]: "ACH Cleared for Delivery",
  [B2BWaveOrderStatus.ACH_FAILED]: "ACH_FAILED",
  [B2BWaveOrderStatus.ACH_VOIDED]: "ACH_VOIDED",
  [B2BWaveOrderStatus.COD_VERIFIED]: "2. COD Verified",
  [B2BWaveOrderStatus.ACH_PROCESSING]: "ACH Processing"
};

// src/b2bwave-product-statuses.ts
var B2BWaveProductStatuses = {
  AVAILABLE: 1,
  BACKORDER: 6,
  INQUIRE: 9
};
var B2BWaveProductStatusName = {
  [B2BWaveProductStatuses.AVAILABLE]: "Available",
  [B2BWaveProductStatuses.BACKORDER]: "Backorder",
  [B2BWaveProductStatuses.INQUIRE]: "Inquire"
};

// src/grizzly-pine-customer-ids.ts
var GRIZZLY_PINE_CUSTOMER_IDS = [
  304,
  303,
  300,
  299,
  282,
  261,
  217,
  205,
  118,
  95,
  72,
  49,
  6,
  35
];
export {
  B2BWaveOrderStatus,
  B2BWaveOrderStatusName,
  B2BWaveProductStatusName,
  B2BWaveProductStatuses,
  BROWSER_CACHE_TTL_MS,
  DEV_BROWSER_CACHE_TTL_MS,
  GRIZZLY_PINE_CUSTOMER_IDS,
  PROD_BROWSER_CACHE_TTL_MS,
  REDIS_CACHE_TTL_SEC
};
